const API = import.meta.env.VITE_API_URL || 'http://localhost:4000/api';

const TOKEN_KEY = 'mlis.token';
const USER_KEY = 'mlis.user';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getStoredUser = () => {
  try { return JSON.parse(localStorage.getItem(USER_KEY) || 'null'); }
  catch { return null; }
};

export const authProvider = {
  async login({ username, password }) {
    const res = await fetch(`${API}/admin/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: username, password }),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body?.error?.message || 'Login failed');
    }
    const { token, user } = await res.json();
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    return Promise.resolve();
  },

  async logout() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    return Promise.resolve();
  },

  async checkAuth() {
    return getToken() ? Promise.resolve() : Promise.reject();
  },

  async checkError(error) {
    const status = error?.status || error?.response?.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
      return Promise.reject({ message: 'Session expired. Please log in again.' });
    }
    return Promise.resolve();
  },

  async getIdentity() {
    const u = getStoredUser();
    if (!u) return Promise.reject();
    return { id: u.id, fullName: u.name, email: u.email, role: u.role };
  },

  async getPermissions() {
    return getStoredUser()?.role || null;
  },
};
